import React from "react";
import "../spinner3.css";

export default function LoadingSpinner3() {
  return (
    <div className="spinner3">
        {/* <span>Loading...</span> */}
    <div className="half-spinner2"></div>
    </div>
  );
}